import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

@observer
export class Balance extends Component {
  render() {
    const { amount, currencyType } = this.props;
    return (
      <span>
        {amount} {currencyType}
      </span>
    );
  }
}

Balance.propTypes = {
  amount: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired
  ]).isRequired,
  currencyType: PropTypes.string
};

Balance.defaultProps = {
  amount: 0
};
export default Balance;



// WEBPACK FOOTER //
// ./src/components/my-account/BalanceUser/Balance/index.jsx